/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import OptionWrapper from "../others/option-wrapper";
import PropTypes from 'prop-types';
import { forwardRef, memo, useImperativeHandle, useMemo, useRef } from 'react';
import { boxBorder, displayFlex, flexRow, itemsCenter, justifyEnd, order, parseWidth, positionRelative } from "../../styles/general";
import { classNames } from "../../utils";
import { responsivePaddingCSS } from "./header";
const ModalFooter = /*#__PURE__*/memo( /*#__PURE__*/forwardRef(({
  action = {},
  boxShadow,
  children,
  className,
  id,
  style
}, reference) => {
  if (!reference) reference = useRef(null);
  const ref = useRef(null);
  const _ModalFooterCSS = ModalFooterCSS(boxShadow);
  useImperativeHandle(reference, () => {
    const currentRef = ref.current || {};
    currentRef.element = ref.current;
    const _instance = {
      ...action
    }; // methods
    _instance.__proto__ = {}; // hidden methods
    currentRef.instance = _instance;
    return currentRef;
  });
  return useMemo(() => {
    return jsx("div", {
      css: _ModalFooterCSS,
      ref: ref,
      id: id,
      className: classNames('DGN-UI-Modal-Footer', className),
      style: style
    }, children);
  }, [boxShadow, children, className, id, style]);
}));
const ModalFooterCSS = boxShadow => css`
    ${displayFlex};
    ${flexRow};
    ${positionRelative};
    ${itemsCenter};
    ${justifyEnd};
    ${boxBorder};
    ${parseWidth('100%')};
    ${order(3)};
    border-radius: 0px 0px 4px 4px;
    box-shadow: ${boxShadow};
    ${responsivePaddingCSS};
`;
ModalFooter.defaultProps = {
  boxShadow: '0px -1px 1px rgba(0, 0, 0, 0.25)',
  className: '',
  style: {}
};
ModalFooter.propTypes = {
  /** The box-shadow of component. */
  boxShadow: PropTypes.string,
  /** The content of the component. */
  children: PropTypes.node,
  /** Class for component. */
  className: PropTypes.string,
  /** Style inline of component. */
  style: PropTypes.object
};
export { ModalFooter };
export default OptionWrapper(ModalFooter);